import CompRebateLayoutOne from '@/components/rebate/comp-rebate-layout-one/index.vue';
import rebateMixin from '@/mixins/nov-new-rebate';
import { getRebateSum } from '@/service/rebate/novNewRebate';
import Vue from 'vue';
import { Step, Steps } from 'vant';
Vue.use(Step);
Vue.use(Steps);

export default {
    name: 'nov-new-rebate-home',
    mixins: [rebateMixin],
    components: {
        CompRebateLayoutOne,
    },
    data() {
        return {
            isRebateHome: true,
            show: false,
        };
    },
    methods: {
        //  初始化页面
        init() {
            const { startTime, endTime, agentId, userInfo, curActivityId, curSystemId } = this;
            getRebateSum({
                startTime,
                endTime,
                userId: agentId,
                systemId: curSystemId,
                levelId: userInfo.levelId,
                actId: curActivityId,
            }).then(data => {
                this.rebateInfo = data;
            });
        },

        // 达标奖励
        handleRecomendDetail() {
            this.show = true;
        },

        handleOk() {
            this.show = false;
        },

        changeSelectedActivity(value) {
            this.curActivity = value;
        },

        changeSelectedSystem(value) {
            this.curSystem = value;
        }
    },
};
